export const Ativo = [
    { id: 0, label:'Não'},
    { id: 1, label:'Sim'},
]

export const AtivoString = [
    { id: "N", label: "Inativa" },
    { id: "S", label: "Ativa" }
]
